// extracted by mini-css-extract-plugin
var _1 = "PopupContent_wrapper__Gp-GI";
export { _1 as "wrapper" }
